import storage from 'local-storage-fallback'
import App from 'modules/App'
import React from 'react'
import ReactDOM from 'react-dom'
import 'global.scss'

if (!('localStorage' in window)) {
  global.localStorage = storage
}

console.logXHR = console.error

if (process.env.NODE_ENV === 'production') {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/frontend/react-app/sw.js', {
          scope: '/',
        })
        .catch(() => {})
    })
  }
}

ReactDOM.render(<App />, document.getElementById('app-root'))
